export const aboutData = {
  brandName: '蓝色导航发布页',
  tagline: '让每一次发布都精准触达',
  foundedYear: '2020',
  teamSize: '50+',
  servedUsers: '500,000+',
  totalLinks: '10,000+',
  mission: '我们的使命是打造中国最专业、最全面的内容发布与网站导航平台，帮助每一位创作者和运营者高效完成内容上线与流量导引，让优质内容被更多人发现。',
  vision: '成为中文互联网领域首选的导航发布管理平台，构建连接内容创作者与目标用户的高效桥梁。',
  story: `蓝色导航发布页诞生于2020年，创始团队来自互联网行业的资深从业者。在工作中，我们发现一个普遍存在的问题：无论是内容创作者还是网站运营者，都面临"内容发布效率低、导航资源分散、流量获取困难"的困境。

于是，我们决定打造一个一站式的解决方案——将内容发布管理与网站导航整合到一个平台上。经过数月的研发和反复测试，蓝色导航发布页正式上线。

从最初的几十个导航链接和少量文章开始，如今我们已经收录了超过10,000个优质网站链接，覆盖8大核心分类，服务超过50万用户。我们的内容团队持续产出高质量的行业资讯和运营指南，帮助用户提升内容发布效率和网站运营能力。

我们始终坚持以用户需求为导向的产品理念，不断优化平台功能和用户体验。每一次迭代、每一篇内容，都承载着我们对"让每一次发布都精准触达"这一使命的坚持。`,
  values: [
    {
      title: '用户至上',
      description: '始终从用户需求出发，打磨每一个功能细节，提供最优质的使用体验。',
      icon: 'ri-user-heart-line',
    },
    {
      title: '品质承诺',
      description: '严格把控内容质量和导航链接的相关性，确保每一个推荐都对用户有价值。',
      icon: 'ri-shield-check-line',
    },
    {
      title: '持续创新',
      description: '紧跟互联网发展趋势，不断引入新技术、新功能，保持平台的先进性和竞争力。',
      icon: 'ri-lightbulb-flash-line',
    },
    {
      title: '开放共赢',
      description: '与内容创作者、网站运营者共建生态，实现平台、创作者、用户的多方共赢。',
      icon: 'ri-team-line',
    },
  ],
  achievements: [
    { number: '500,000+', label: '累计服务用户' },
    { number: '10,000+', label: '收录优质网站' },
    { number: '8', label: '核心分类覆盖' },
    { number: '99.9%', label: '服务可用率' },
  ],
  contact: {
    email: 'contact@bluenav.com',
    phone: '400-888-6666',
    address: '北京市海淀区中关村科技园区',
    wechat: 'blue_nav_official',
    weibo: '@蓝色导航发布页',
  },
};